<template>
    <b-modal
        id="too-many-students-modal"
        v-model="loaded"
        ref="too-many-students-modal"
        size="md"
        :title="$t('internship.too_much_students')"
        modal-class="apprentice-default-modal too-many-students"
        :ok-title="$t('internship.ready')"
        :cancel-title="$t('common.cancel')"
        :ok-disabled="students.length > slots"
        @ok="save()">
        <p>
            {{
                $t(
                    'internship.the_number_of_internship_places_is_now_less_than_the_number_of_registrations_which_students_do_you_want_to_remove_reject',
                )
            }}
        </p>
        <design-2021-apprentice-data-table
            :items="tableData"
            :fields="studentFields"
            show-empty>
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-sign-out btn-module-sign-out remove-icon-margin"
                    v-b-tooltip:hover
                    variant="danger-icon-only"
                    :title="$t('internship.remove_reject')"
                    @click="openSignoutModal(data.item)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-internship-edit-enrolled-students-tab-signout-modal-component
            @signout="signOut($event)"
            ref="signout-student-modal"
            :internship-in="internshipIn">
        </design-2021-internship-edit-enrolled-students-tab-signout-modal-component>
        <design-2021-internship-edit-applying-students-tab-rejection-modal-component
            @reject="signOut($event)"
            ref="reject-student-modal"
            :internship-in="internshipIn">
        </design-2021-internship-edit-applying-students-tab-rejection-modal-component>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-internships-edit-details-tab-less-slots-then-students-modal-component',
    props: ['internshipIn', 'studentsIn'],
    data() {
        return {
            loaded: false,
            slots: null,
            students: this.studentsIn,
            studentFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                },
                {
                    key: 'status',
                    label: 'status',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.students.map((student) => {
                return {
                    id: student.id,
                    name: student.full_name,
                    email: student.email,
                    status: student.pivot.accepted,
                };
            });
        },
    },
    methods: {
        load(slots) {
            if (!this.loaded) {
                this.slots = slots;
                this.loaded = true;
            }
        },
        openSignoutModal(student) {
            if (student.status) {
                this.$refs['signout-student-modal'].show(student.id);
            } else {
                this.$refs['reject-student-modal'].show(student.id);
            }
        },
        signOut(userId) {
            this.students = this.students.filter((item) => item.id !== userId);
            this.$emit('signOut', userId);
        },
        save() {
            this.emit('save');
        },
    },
};
</script>

<style scoped></style>
